export const getCountryFromLocale = (locale: string): string => {
  if (!locale) return undefined;
  const splittedLocale = locale.split('-');
  if (splittedLocale.length !== 2) return undefined;
  return splittedLocale[1];
};

export const getProduct = (user: User): Product => (user ? user.product : null);
